import React from 'react';
import styled from 'styled-components';
import { Causer } from '../causer';

const RequestedResourceStyled = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  .request-status {
    display: flex;
    align-items: center;
    gap: var(--spacing-02);
  }
`;

// Define interfaces for props and potential data structures
interface User {
  firstName: string;
  lastName: string;
  photoUrl?: string;
}

interface Team {
  teamName: string;
}

interface RequestedResourceProps {
  team?: Team;
  user?: User;
}

interface RequestedResourceData {
  firstName: string;
  lastName: string;
  photoUrl?: string;
}

export const RequestedResource: React.FC<RequestedResourceProps> = ({
  team,
  user,
}) => {
  let requestedResource: RequestedResourceData;

  if (team) {
    requestedResource = { firstName: team.teamName, lastName: '' };
  } else if (user) {
    requestedResource = {
      firstName: user.firstName,
      lastName: user.lastName,
      photoUrl: user.photoUrl,
    };
  } else {
    requestedResource = { firstName: '', lastName: '' };
  }

  return (
    <RequestedResourceStyled>
      <Causer user={requestedResource} />
    </RequestedResourceStyled>
  );
};
